export enum LanguageKey {
  GE = 'ge',
  EN = 'eng',
}
